import {serviceWorkerCommunicator} from './serviceWorker/sw'
(new serviceWorkerCommunicator).init();
(function() {
    require('./pages/common');
})();


